// ----------------------------------------------------------------------

export default function Popover(theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z12,
          border: `2px solid ${theme.palette.pixelInk}`
        }
      }
    }
  };
}
